module.exports = __webpack_public_path__ + "img/person-blue.49e9c6d1.svg";